import React from "react";
import { styled } from "@mui/system";
import Box from "../Box";

type Props = {
  children?: React.ReactNode;
  variant?: "card" | "form";
};

export const VaporPage = styled(
  (props: Props) => (
    <Box
      sx={{
        margin: 0,
        backgroundColor: "primary.background",
        padding: props.variant === "card" ? "20px" : 0,
        textAlign: "left",
        maxWidth: "100%",
        "@media screen and (max-width: 1600px)": {
          padding: "0px !important",
        },
      }}
    >
      {props.children}
    </Box>
  ),
  {
    name: "VaporPage",
    slot: "Root",
    overridesResolver: (props, styles) => [],
  }
)(({ theme }) => ({}));
